<template>
<div class="content">
  <img :src="locationImage" class="header-image" />

  <section id="locations">
    <div class="section-content">
      <h1>BigYellowBag<sup>&reg;</sup> Locations</h1>
      <p>Contact us at the location nearest you</p>
      <p v-if="locationAlert" class="alert">Location Page not found</p>

      <locations-map :locations="locations"></locations-map>

      <div class="centred" style="margin-top: 2.62em">
        <a href="/orders/new" class="get-notify postal button">Order Now!</a>
      </div>
    </div>
  </section>
</div>
</template>

<script>
import Rails from 'rails-ujs';
import LocationsMap from '../../containers/locations/locations-map.vue';
import LocationImage from '../../../../public/images/locations-banner.jpg';

export default {
  data() {
    return {
      locations: [],
      locationImage: LocationImage,
    };
  },

  props: {
    locationAlert: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    LocationsMap,
  },

  created() {
    this.fetchLocations();
  },

  methods: {
    fetchLocations() {
      // TODO: Add error handling
      Rails.ajax({
        type: 'GET',
        url: '/all_partners',
        success: (response) => {
          this.locations = response;
        },
      });
    },
  },
};
</script>

<style>

</style>
